function initializeNeedPhoneCollection() {
(function () {
  let updateScheduled = false;

  function removeAddonProducts() {
    document
      .querySelectorAll('a[href^="/products/need-a-phone-protection-plan"]')
      .forEach(function (link) {
        const productCard = link.closest('.boost-sd__product-item');

        if (productCard) productCard.remove();
      });
  }

  function updateProductGrid() {
    updateScheduled = false;

    removeAddonProducts();

    document
      .querySelectorAll('.boost-sd__product-title')
      .forEach(function (title) {
        // Prevent processing the same title twice
        if (title.querySelector('.napi-variant-line')) return;

        const fullTitle = title.textContent
          .replace(/\s+/g, ' ')
          .trim();

        const titleParts = fullTitle
          .split(' - ')
          .map(function (part) {
            return part.trim();
          })
          .filter(Boolean);

        // We need at least a main title and two variant values
        if (titleParts.length < 3) return;

        // Last two values:
        // Phantom Gray - 128GB
        // or 256GB - Aura Glow
        const variantText = titleParts.splice(-3).join(' • ');
        const mainText = titleParts.join(' • ');

        const mainLine = document.createElement('span');
        mainLine.className = 'napi-main-title';
        mainLine.textContent = mainText;

        const variantLine = document.createElement('span');
        variantLine.className = 'napi-variant-line';
        variantLine.textContent = variantText;

        title.textContent = '';
        title.appendChild(mainLine);
        title.appendChild(variantLine);
      });
  }

  function scheduleUpdate() {
    if (updateScheduled) return;

    updateScheduled = true;
    requestAnimationFrame(updateProductGrid);
  }

  scheduleUpdate();

  // Runs again after filtering, sorting or loading more products
  const observer = new MutationObserver(scheduleUpdate);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


// Quick filters use Boost's collection URLs, so results include every page.
(function () {
  // Shopify prefixes translated collection URLs with the locale (for example /fr/).
  if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\//i.test(location.pathname)) return;
  const isFrench = /^fr(?:-|$)/i.test(document.documentElement.lang) || /^\/fr(?:-[a-z]{2})?\//i.test(location.pathname);
  const translate = (english, french) => isFrench ? french : english;
  document.documentElement.classList.add('nap-sidebar-toggle-enabled');
  let sidebarExpanded = false;
  const priceKey = 'pf_p_price';
  const storageKey = 'pf_opt_storage';
  const presets = [
    { label: translate('All', 'Tous'), key: null },
    { label: translate('Under $300', 'Moins de 300 $'), key: priceKey, values: ['0:299.99'] },
    { label: translate('$300–$600', '300 $–600 $'), key: priceKey, values: ['300:600'] },
    { label: translate('Excellent only', 'État excellent uniquement'), key: 'pf_opt_condition', values: ['Excellent'] },
    { label: translate('Fair', 'État correct'), key: 'pf_opt_condition', values: ['Fair'] },
    { label: translate('128GB+', '128 Go et plus'), key: storageKey, values: ['128GB', '256GB', '512GB'] },
    {
      label: translate('256GB+', '256 Go et plus'),
      key: storageKey,
      values: ['256GB', '512GB', '1TB']
    },
    {
      label: '4G',
      key: 'pf_m_::custom::cellular_technology',
      values: ['4G']
    },
    { label: '5G', key: 'pf_m_::custom::cellular_technology', values: ['5G'] },
    {
      label: translate('Physical SIM', 'SIM physique'),
      key: 'pf_m_::custom::sim_type',
      values: ['Physical SIM']
    },
    { label: translate('Physical & eSIM', 'SIM physique et eSIM'), key: 'pf_m_::custom::sim_type', values: ['Physical & eSIM'] },
    {
      label: translate('Wireless Charging', 'Recharge sans fil'),
      key: 'pf_t_wireless_charging',
      values: ['Yes']
    }
  ];
  let scheduled = false;
  function update() {
    scheduled = false;
    const toolbar = document.querySelector('.boost-sd__toolbar');
    if (!toolbar) return;
    const filterLabel = toolbar.querySelector('.boost-sd__filter-tree-toggle-button-title--refine-by');
    if (filterLabel) {
      const label = window.matchMedia('(max-width: 767px)').matches
        ? translate('More filters', 'Plus de filtres')
        : translate('Filters', 'Filtres');
      if (filterLabel.textContent.trim() !== label) filterLabel.textContent = label;
    }
    let bar = document.querySelector('.nap-quick-filters');
    if (!bar) {
      bar = document.createElement('nav');
      bar.className = 'nap-quick-filters';
      bar.setAttribute('aria-label', translate('Quick product filters', 'Filtres rapides des produits'));
      enableQuickFilterDragging(bar);
      // Keep Boost's delegated controls from handling these normal navigation links.
      bar.addEventListener('click', event => event.stopPropagation());
      presets.forEach(preset => {
        const link = document.createElement('a');
        link.className = 'nap-quick-filters__pill';
        link.textContent = preset.label;
        bar.append(link);
      });
    }
    const anchor = toolbar.closest('.boost-sd__toolbar-container') || toolbar;
    if (window.matchMedia('(max-width: 767px)').matches) {
      if (anchor.previousElementSibling !== bar) anchor.before(bar);
    } else {
      if (anchor.nextElementSibling !== bar) anchor.after(bar);
    }
    const sidebar = document.getElementById('boost-sd-filter-tree-column');
    let toggle = document.querySelector('.nap-quick-filters__more');
    if (sidebar && !toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'nap-quick-filters__pill nap-quick-filters__more';
      toggle.setAttribute('aria-controls', sidebar.id);
      toggle.addEventListener('click', event => {
        event.stopPropagation();
        sidebarExpanded = !sidebarExpanded;
        document.documentElement.classList.toggle('nap-sidebar-expanded', sidebarExpanded);
        update();
      });
      bar.after(toggle);
    }
    if (toggle) {
      const toggleAnchor = window.matchMedia('(max-width: 767px)').matches ? anchor : bar;
      if (toggleAnchor.nextElementSibling !== toggle) toggleAnchor.after(toggle);
      const label = sidebarExpanded
        ? translate('Less filters', 'Moins de filtres')
        : translate('More filters', 'Plus de filtres');
      if (toggle.textContent !== label) toggle.textContent = label;
      toggle.setAttribute('aria-expanded', String(sidebarExpanded));
    }
    const params = new URLSearchParams(location.search);
    presets.forEach((preset, index) => {
      const link = bar.children[index];
      let values = preset.values;
      if (preset.key === storageKey) {
        const available = Array.from(document.querySelectorAll('[data-filteroptionid="pf_opt_storage"] [role="checkbox"]'))
          .map(item => item.textContent.trim())
          .filter(value => /^(\d+(?:\.\d+)?)\s*(GB|TB)$/i.test(value))
          .filter(value => parseFloat(value) * (/TB/i.test(value) ? 1024 : 1) >= 128);
        if (available.length) values = [...new Set([...preset.values, ...available, ...params.getAll(storageKey)])].filter(value => parseFloat(value) * (/TB/i.test(value) ? 1024 : 1) >= 128);
      }
      const current = preset.key ? params.getAll(preset.key) : [];
      const active = preset.key
        ? current.length === values.length && values.every(value => current.includes(value))
        : !Array.from(params.keys()).some(key => key.startsWith('pf_') || key.startsWith('filter.'));
      const next = new URLSearchParams(params);
      next.delete('page');
      if (!preset.key) {
        [...next.keys()].forEach(key => { if (key.startsWith('pf_') || key.startsWith('filter.')) next.delete(key); });
      } else {
        next.delete(preset.key);
        if (!active) values.forEach(value => next.append(preset.key, value));
      }
      const query = next.toString();
      const href = location.pathname + (query ? '?' + query : '');
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('popstate', schedule);
  window.matchMedia('(max-width: 767px)').addEventListener('change', schedule);
  schedule();
})();

}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeNeedPhoneCollection, { once: true });
} else {
  initializeNeedPhoneCollection();
}

// Keep Boost's existing close action; only change its mobile presentation.
(function () {
  const mobile = matchMedia('(max-width: 767px)');
  let scheduled = false;
  function update() {
    scheduled = false;
    const selected = !!document.querySelector('[data-filteroptionid] [aria-checked="true"]') ||
      Array.from(new URLSearchParams(location.search).keys()).some(key => key.startsWith('pf_') || key.startsWith('filter.'));
    document.querySelectorAll('.boost-sd__filter-tree-vertical-close-filter .boost-sd__button--close').forEach(button => {
      const done = mobile.matches && selected;
      const isFrench = /^fr(?:-|$)/i.test(document.documentElement.lang);
      const label = done ? (isFrench ? 'Terminé' : 'Done') : (isFrench ? 'Fermer' : 'Close');
      button.classList.toggle('nap-filter-done', done);
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      if (button.getAttribute('data-done-label') !== label) button.setAttribute('data-done-label', label);
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['aria-checked']
  });
  document.addEventListener('change', schedule);
  window.addEventListener('popstate', schedule);
  mobile.addEventListener('change', schedule);
  schedule();
})();

// Mouse dragging complements the row's native touch scrolling.
function enableQuickFilterDragging(bar) {
  let gesture = null;
  let suppressClick = false;
  bar.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    suppressClick = false;
    gesture = { id: event.pointerId, x: event.clientX, scroll: bar.scrollLeft, dragging: false };
  });
  bar.addEventListener('pointermove', event => {
    if (!gesture || event.pointerId !== gesture.id) return;
    const distance = event.clientX - gesture.x;
    if (!gesture.dragging && Math.abs(distance) < 6) return;
    if (!gesture.dragging) {
      gesture.dragging = true;
      bar.setPointerCapture(event.pointerId);
      bar.classList.add('is-dragging');
    }
    event.preventDefault();
    bar.scrollLeft = gesture.scroll - distance;
  });
  function finish(event) {
    if (!gesture || event.pointerId !== gesture.id) return;
    suppressClick = gesture.dragging;
    gesture = null;
    bar.classList.remove('is-dragging');
    if (bar.hasPointerCapture(event.pointerId)) bar.releasePointerCapture(event.pointerId);
  }
  bar.addEventListener('pointerup', finish);
  bar.addEventListener('pointercancel', finish);
  bar.addEventListener('lostpointercapture', finish);
  bar.addEventListener('pointerleave', event => {
    if (gesture && !gesture.dragging) finish(event);
  });
  bar.addEventListener('dragstart', event => event.preventDefault());
  bar.addEventListener('click', event => {
    if (!suppressClick || event.detail === 0) return;
    suppressClick = false;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
}
